import { isFeatureEnabled } from 'owa-feature-flags';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';

const supportedOfficeRailApps = [
    'Yammer',
    'Bookings',
    'OrgExplorer',
    'com.microsoft.teamspace.tab.planner',
    '2e3a628d-6f54-4100-9e7a-f00bc3621a85',
    'db5e5970-212f-477f-a3fc-2227dc7782bf',
];

export default function isSupportedOfficeRailApp(appName: string) {
    return (
        !isBrowserIE() &&
        isFeatureEnabled('tri-officeRailHost') &&
        supportedOfficeRailApps.includes(appName)
    );
}
